import { FormulaType } from '../../constants/formulaType';

import { RelatedMessagesPerformanceFilterParams } from '../../models/label.model';
import {
    LivePerformanceMessageState,
    ViewByName,
} from '../../models/live-messages.model';
import {
    TOP_METRICS_CARDS_VIEW_BY,
    TOP_PERFORMING_METRICS,
} from '../../models/metrics.model';
import {
    ChartsRequestParams,
    MetricParams,
    MonitoringTabs,
} from '../../models/monitoring.model';

const metricKeys = {
    monitoringChartOptions: (view: MonitoringTabs) => ['chart-options', view],
    monitoringCharts: (params: ChartsRequestParams) => [
        'monitoring-charts',
        params.metric_name,
        params.time_frame,
        params.breakdown,
        params.filter_by,
        params.filter_detail,
        params.start_date,
    ],
    monitoringChartFilterOptions: (filterType: MetricParams) => [
        'chart-filter-options',
        filterType,
    ],
    weekInProgressMetrics: () => ['week_in_progress'],
    metricsInfo: () => ['metrics-info'],
    personalizationLabelVariantMetrics: (
        labelId: number,
        variantType: string,
    ) => ['personalization_label_variant_metrics', labelId, variantType],
    topNLabelAlternateMetrics: (
        labelId: number,
        topN: number,
        variantType: string,
    ) => ['top_label_variant_metrics', labelId, variantType, topN],
    controlledFormulaMetrics: (
        formulaType: FormulaType,
        viewBy: ViewByName,
    ) => ['controlled_formula_metrics', formulaType, viewBy],
    topFormulaMetrics: (metricName: TOP_PERFORMING_METRICS) => [
        'top_formula_metrics',
        metricName,
    ],
    topLabelMetrics: (
        metricName: TOP_PERFORMING_METRICS,
        variant_type: string,
    ) => ['top_label_metrics', metricName, variant_type],
    dailyImpactMetrics: (viewBy: TOP_METRICS_CARDS_VIEW_BY) => [
        'daily_impact_metrics',
        viewBy,
    ],
    topTriggerMetrics: (metricName: TOP_PERFORMING_METRICS) => [
        'top_trigger_metrics',
        metricName,
    ],
    clusterCount: () => ['cluster-count'],
    messageStateCount: (
        messageType: FormulaType,
        messageState: LivePerformanceMessageState,
    ) => ['message-state-count', messageType, messageState],
    labelFormulaLevelMetrics: (
        labelId: number,
        param: RelatedMessagesPerformanceFilterParams,
    ) => ['metrics', labelId, param.variant_type, param.nDays],
    labelAlternateFormulaLevelMetrics: (
        labelId: number,
        param: RelatedMessagesPerformanceFilterParams,
    ) => [
        'label-alternate-formula-metrics',
        labelId,
        param.variant_type,
        param.nDays,
    ],
    formulaLevelMetrics: (
        labelId: number,
        param: RelatedMessagesPerformanceFilterParams,
    ) => ['formula-level-metrics', labelId, param.variant_type, param.nDays],
    labelRealTimeFormulaMetrics: (labelId: number, nDays: number) => [
        'label-real-time-formula-metrics',
        labelId,
        nDays,
    ],
};

export default metricKeys;
